import { createSlice } from "@reduxjs/toolkit";
import {
  addState,
  editState,
  getState,
  getStateList,
} from "../services.js/state-services";

const initialState = {
  states: [],
  state: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const stateSlice = createSlice({
  name: "state",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getStateList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getStateList.fulfilled, (state, action) => {
        state.states = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getStateList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getState.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getState.fulfilled, (state, action) => {
        state.states = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getState.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addState.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addState.fulfilled, (state, action) => {
        state.states = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addState.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editState.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editState.fulfilled, (state, action) => {
        state.state = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editState.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      
  },
});
export const { resetSuccess, resetState, resetError } = stateSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default stateSlice.reducer;
